import axios from 'axios'
import { axiosUrl } from '@/utils/setting'

const USER_STORAGE_KEY = 'youcai_user'
const SUCCESS_CODE = 200

export const request = axios.create({
    baseURL: axiosUrl,
    timeout: 20000
})

const getStoredToken = () => {
    try {
        const rawUser = localStorage.getItem(USER_STORAGE_KEY)
        const userInfo = rawUser ? JSON.parse(rawUser) : null
        return userInfo && userInfo.access_token ? userInfo.access_token : ''
    } catch (error) {
        return ''
    }
}

request.interceptors.request.use((config) => {
    const token = getStoredToken()
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    config.headers.sourceType = '4'
    config.headers['Content-Type'] =
        config.headers['Content-Type'] || 'application/json;charset=UTF-8'

    return config
})

request.interceptors.response.use(
    (response) => {
        const result = response.data

        if (String(result && result.code) === String(SUCCESS_CODE)) {
            return result
        }

        return Promise.reject({
            code: result && result.code,
            msg: (result && result.msg) || '请求失败',
            data: result && result.data
        })
    },
    (error) => {
        const response = error && error.response
        const data = response && response.data

        return Promise.reject({
            code: (data && data.code) || (response && response.status) || -1,
            msg: (data && data.msg) || error.message || '请求失败',
            data: data && data.data
        })
    }
)

export const loginByAccount = ({ username, password }) =>
    request.post('/auth/client/pwdLogin', {
        username,
        password,
        wxcode: null,
        userType: 3
    })

export const getInfo = (params = {}, token) =>
    request.get('/szg-admin/api/app/getInfo', {
        params,
        headers: token ? { Authorization: `Bearer ${token}` } : undefined
    })

export const codeCaptcha = () => request.get('/codeCaptcha')

export const sendSmsCode = ({ phone, uuid, code }) =>
    request.post('/auth/client/sms/sendCode', { phone, uuid, code })

export const loginBySms = ({ mobile, code, uuid, sliderCode }) =>
    request.post('/auth/client/smsCode/login', {
        phone: mobile,
        smsCode: code,
        wxcode: null,
        uuid,
        code: sliderCode
    })
